// the default token list lives here
export const DEFAULT_TOKEN_LIST_URL = '/tokenlist.json'

export const DEFAULT_LIST_OF_LISTS: string[] = ['/tokenlist.json']
